import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaRegClock, FaHeart, FaRegHeart, FaLock } from "react-icons/fa";

import { logEvent } from "firebase/analytics";
import { analytics } from "../../firebase";

import { useFavoriteStory } from "../../hooks/useFavoriteStory";
import { useAuth } from "../../context/AuthContext";
import { useUserData } from "../../context/UserDataContext";
import PaywallModal from "../modals/PaywallModal";

import "./StoryCard.css";

export default function StoryCard({ story }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [isFavorite, toggleFavorite] = useFavoriteStory(story, user);
  const { userData } = useUserData();

  const [showPaywall, setShowPaywall] = useState(false);
  const isPaidUser = userData?.hasAccess && userData?.subscriptionStatus === "active";
  const canAccess = isPaidUser || story.access === "free";
  const locked = !isPaidUser && story.access === "paid";  

  const handleFavoriteClick = (e) => {
    e.stopPropagation();
    toggleFavorite();
  };



  const levelMap = {
    A1: "Iniciante",
    A2: "Iniciante",
    B1: "Intermediário",
    B2: "Intermediário",
    C1: "Avançado",
    C2: "Avançado",
  };

  const levelLabel = levelMap[story.level] || story.level;

  return (
    <>
      <div
        className="story-card"
        onClick={() => {
          if (!canAccess) {
            if (analytics) {
              logEvent(analytics, "paywall_viewed", {
                trigger: "locked_story",
                story_id: story.id
              });
            }
            setShowPaywall(true);
            return;
          }  

          if (analytics) {
            logEvent(analytics, "story_opened", {
              story_id: story.id
            });
          }
          navigate(`/story/${story.id}`);
        }}
      >
      <div className="story-card-image-wrapper">
        <img
          src={story.cardImage}
          alt={story.title}
          className="story-card-image"
        />
        <div className="story-card-gradient"></div>
        {/* TOP RIGHT — frases */}
        <span className="story-card-sentences-floating">
          <FaRegClock className="story-card-meta-icon" />
          {story.estimatedMinutes || 0} min
        </span>

        {/* BOTTOM LEFT — title */}
        <h3 className="story-card-title-floating">
          {story.title}
        </h3>

        {/* BOTTOM RIGHT — level */}
        <span className="story-card-level-floating">
          <span className={`story-card-level-icon level-${(story.level || "").toLowerCase()}`}>
            {story.level || ""}
          </span>
        </span>

        {locked && (
          <div className="story-card-lock-overlay">
            <FaLock size={26} color="var(--color-background-white)" />
          </div>
        )}
      </div>

  
            {/* <button className="story-card-fav-btn" onClick={handleFavoriteClick}>
              {isFavorite ? (
                <FaHeart size={19} color="#606060" />
              ) : (
                <FaRegHeart size={18} color="#4c4c4d" />
              )}
            </button> */}

          {/* BOTTOM LEFT — Title */}




          </div>
  
      {/* ✅ Paywall Modal (rendered after the card, stays on top of everything) */}
      {showPaywall && <PaywallModal onClose={() => setShowPaywall(false)} />}
    </>
  );
}  
